import { DELETE_PARTY_DISCOUNT } from "../../types/PartyDiscountType";
import axios from "axios";

const deletePartyDiscount = (id) => {
	return {
		type: DELETE_PARTY_DISCOUNT,
		payload: id,
	};
};

export const DeletePartyDiscount = (id) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			await axios({
				method: "patch",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `product-currency/${id}`,
				data: {
					status: false,
				},
			});
			//dispatching data
			dispatch(deletePartyDiscount(id));
		} catch (error) {
			console.log(error.message);
		}
	};
};
